import { createSelector } from 'reselect';
import { formatDateForItem } from 'utils/formatting';
import { selectSpaces } from 'features/spaces/reducers/selectors';
export const selectNotificationsListIsFetching = (store, spaceId) => store.notifications.isFetching?.[spaceId] || false;
export const selectNotificationsListSpacePage = (store, spaceId) => store.notifications.spacePage[spaceId];
export const selectNotificationsListSpacePageCount = (store, spaceId) => store.notifications.spacePageCount[spaceId];
export const selectNotificationsListSections = createSelector([
    (store) => store.notifications.spaceNotifications,
    selectSpaces,
    (_store, spaceId) => spaceId,
], (spaceNotifications, spaces, spaceId) => {
    const notificationItems = [];
    const space = spaces.find((space) => space.id === spaceId);
    const notificationsArray = spaceNotifications[spaceId];
    // if space is default, add -1 notifications as well
    if (space?.isDefault && spaceNotifications[-1]) {
        notificationsArray.push(...spaceNotifications[-1]);
    }
    let activeDate = '';
    let index = 0;
    notificationsArray?.forEach((notification) => {
        if (notification.datetime.substring(0, 10) !== activeDate.substring(0, 10)) {
            activeDate = notification.datetime;
            notificationItems.push({
                type: 'SECTION_HEADER',
                id: notification.datetime,
                sectionTitle: formatDateForItem(notification.datetime),
            });
            index += 1;
        }
        notificationItems.push({ ...notification, index });
        index += 1;
    });
    return notificationItems;
});
